import { useEffect } from 'react';
import { enforceBanTokenIfPresent } from '../../services/banTokenService';

/**
 * If this browser has a known ban token and the visitor changed IPs,
 * auto-rebans the current IP and sends them to the fake maintenance page.
 */
const BanTokenEnforcer = () => {
  useEffect(() => {
    let cancelled = false;
    let running = false;
    let redirecting = false;
    let timerId;

    function scheduleNextCheck() {
      window.clearTimeout(timerId);
      if (!cancelled && !redirecting) {
        timerId = window.setTimeout(run, 15000);
      }
    }

    async function run() {
      if (cancelled || running) {
        return;
      }
      running = true;
      try {
        const result = await enforceBanTokenIfPresent();
        if (!cancelled && result?.banned) {
          redirecting = true;
          window.location.replace('/maintenance.html');
          return;
        }
      } catch (err) {
        // Never block the app if enforcement fails.
      } finally {
        running = false;
        scheduleNextCheck();
      }
    }

    function checkWhenVisible() {
      if (document.visibilityState === 'visible') {
        window.clearTimeout(timerId);
        run();
      }
    }

    run();
    document.addEventListener('visibilitychange', checkWhenVisible);
    return () => {
      cancelled = true;
      window.clearTimeout(timerId);
      document.removeEventListener('visibilitychange', checkWhenVisible);
    };
  }, []);

  return null;
};

export default BanTokenEnforcer;
